import { Navigate } from 'react-router-dom';
import { isLogin } from '../utils';

function PrivateRoute({ children }) {
    const logok = isLogin();

    return logok ? children : <Navigate to="/login" />;
}

export default PrivateRoute;
